import { Dialog, DialogContent, LinearProgress } from '@mui/material'
import React, { useState } from 'react'
import portalServices from '../portalServices';
import { useMqtt } from '../../../context/MqttContext';

function SelfCancelAppointment({getAppointmentList, appointmentDetails}) {
    const [dialogStatus,setDialogStatus] = useState(false);
    const [loading,setLoadingStatus] = useState(false);

    //const {publishMessage} = useMqtt();
    
    const confirmCancel = () => {
        setLoadingStatus(true)
        let payload = {
            appointmentId : appointmentDetails.id,
            customerToken : localStorage.getItem('customerToken')
        }
        portalServices.cancelAppointmentSlot(payload).then(res=>{
            if(res.updateStatus > 0){
                getAppointmentList();
                console.log("appointment cancelled")
                //publishMessage({event:"close_token",token:null})
            }
        }).catch(error=>{
            console.log("Here in error",error)
        }).finally(()=>{
            setDialogStatus(false)
            setLoadingStatus(false);
        })
    }
    return (
        <>
            <button className='btn btn-outline-danger btn-lg me-2' onClick={()=>setDialogStatus(true)} >Cancel My Appointment</button>
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
            >
                <DialogContent>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h4>Are you Sure you want to cancel this appointment slot</h4>
                        </div>
                        {loading ?
                            <div className='col-md-12'>
                                <LinearProgress />
                            </div>
                            :
                            <div className='col-md-12'>
                                <button className='btn btn-danger float-end' onClick={confirmCancel}>Yes</button>
                                <button className='btn btn-outline-primary' onClick={()=>setDialogStatus(false)} >No</button>
                            </div>
                        }
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default SelfCancelAppointment